module.exports = __webpack_public_path__ + "img/9.fcb84835.jpg";